<template>
  <div>
    <div class="page-title">Конфиги</div>
    <base-progress-linear v-if="!init"></base-progress-linear>
    <div class="page-content" v-else>
      <v-card>
        <v-card-text>
          <v-combobox
            color="primary"
            outlined
            multiple
            small-chips
            deletable-chips
            data-cy="configTags"
            :items="tags.items"
            :loading="tags.loading"
            v-model="datatable.params.tags"
            label="Тэги">
          </v-combobox>
        </v-card-text>
      </v-card>
      <v-data-table
        :loading="datatable.loading"
        loading-text="Loading... Please wait"
        :headers="datatable.headers"
        :items="datatable.items"
        item-key="id"
        :server-items-length="datatable.totalRecords"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.actions="{ item }">
          <router-link :to="'/config/'+item.configId">
            <v-btn dark icon small class="primary">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </router-link>
          <v-btn dark icon small
                 class="warning"
                 @click="removeConfig(item.configId)"
                 :loading="removeConfigById.loading">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <base-paginator :params="datatable.params" @change="fetchData"></base-paginator>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'List',
  data() {
    return {
      showEditDialog: false,
      init: false,
    };
  },
  computed: {
    ...mapState('config', {
      datatable: (state) => state.datatable,
      tags: (state) => state.tags,
      removeConfigById: (state) => state.removeConfigById,
    }),
  },
  watch: {
    'datatable.params': {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  mounted() {
    const promises = Promise.all([
      this.fetchTags(),
      this.fetchData(),
    ]);

    promises.then(() => { this.init = true; });
  },
  methods: {
    fetchData() {
      return this.$store.dispatch('config/datatable', this.datatable.params);
    },
    fetchTags() {
      return this.$store.dispatch('config/tags');
    },
    async removeConfig(id) {
      await this.$store.dispatch('config/removeConfigById', id);
      this.fetchData();
    },
  },
};
</script>
